import { styled, Dialog } from '@mui/material'

export const Modal = styled(Dialog)(props => `
  >div>div{
    max-width: ${typeof (props?.width) === 'number' ? `${props?.width}px` : props?.width};
    width: 100%;
  }
`)
